module.exports = __webpack_public_path__ + "static/media/comments-alt.2124e3c2.svg";